import React, { useEffect } from 'react';

import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import Autocomplete from '@mui/material/Autocomplete';
import { TextField } from '@mui/material';
import { Select } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import { device_fields } from '../constants/create_device_fields';
import CustomInput from '../../../../components/CustomInput';
import service from '../service';
import { toast } from 'react-toastify';
import { useBoundStore } from '../../../../stores';
import { useNavigate } from 'react-router-dom';

function CreateDeviceDrawer() {
  const [vehicleFormData, setVehicleFormData] = React.useState({
    vehicleId: '',
  });
  const navigate = useNavigate();
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const [valid, setValid] = React.useState(false);
  const [filterData, setFilterData] = React.useState({ query: '' });
  const [vehicle, setVehicle] = React.useState({});
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(0);
  const [sortModel, setSortModel] = React.useState([]);

  async function getData() {
    setIsLoading(true);
    const { field, sort } =
      sortModel.length > 0
        ? sortModel[0]
        : { field: 'createdAt', sort: 'desc' };
    const params = {
      // ...filterData,
      size: 10,
      page: page,
      sort: `${field},${sort}`,
    };
    const result = await service.getVehiclesWithSearch(params);
    const data = result?.data?.data || [];
    setVehicles(data);
    setIsLoading(false);
  }

  const handleFilterInput = (newValue) => {
    setFilterData((prevFilterData) => ({
      ...prevFilterData,
      query: newValue,
    }));
  };

  const [deviceFormData, setDeviceFormData] = React.useState({
    imei: '',
    description: '',
    barcodeNumber: '',
    description: '',
    deviceModel: '',
    version: '',
    status: 'ACTIVE',
  });

  const validateForm = () => {
    if (
      deviceFormData.imei &&
      // deviceFormData.barcodeNumber &&
      deviceFormData.status
    ) {
      setValid(true);
    } else {
      setValid(false);
    }
  };

  const handleSave = async () => {
    console.log(deviceFormData);
    await service.saveDevice(deviceFormData).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Cihaz başarıyla oluşturuldu.');
      } else {
        toast.error('Cihaz oluşturulurken hata oluştu.');
      }
      navigate("/definitions/devices")
      toggleRightDrawer();
    });
  };

  useEffect(() => {
    validateForm();
  }, [deviceFormData]);

  // useEffect(() => {
  //   getData();
  // }, []);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Cihaz Ekle</Typography>
      </div>
      <div>
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {device_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={deviceFormData[field.key]}
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setDeviceFormData({
                          ...deviceFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
              <Button
                disabled={!valid}
                variant="contained"
                color="primary"
                startIcon={<MATERIEL_ICONS.Save />}
                onClick={() => handleSave()}
                className="mx-2"
              >
                Kaydet
              </Button>
            </div>
          </div>
        </>

      </div>
    </div>
  );
}

export default CreateDeviceDrawer;
